module.exports = __webpack_public_path__ + "images/emoji/sake.921edca6c4498a689c29.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sake.png
// module id = Fch6
// module chunks = 14